export const JWT_KEY = 'jwt_access_token';
export const USER_KEY = 'user_details';
